module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon12.84d8ec0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon12.png
// module id = XVn/
// module chunks = 0